<template>
    <div>
        <div @click="toggleLangList">
            <FlagIcon :country="currentLocale.countryCode" size="big" avatar />
        </div>

        <transition name="vertical-slide" mode="out-in">
            <Paper
                v-if="showLangList && !noModal"
                v-on-clickaway="toggleLangList"
                class="locale-dropdown"
            >
                <div
                    v-for="(lang, i) in languages"
                    :key="lang.locale"
                    class="clickable pointer noselect"
                    @click="() => onChange(lang)"
                >
                    <div class="d-flex align-items-center p-2">
                        <div class="mr-2">
                            <FlagIcon
                                :country="lang.countryCode"
                                size="big"
                                avatar
                                avatarSize="small"
                            />
                        </div>
                        <p class="mb-0">
                            {{ $t(`components.builders.localeDropdown.languages.${lang.locale}`) }}
                        </p>
                    </div>
                    <Divider v-if="i < languages.length - 1" />
                    <!-- To make sure the last one does not include the divider -->
                </div>
            </Paper>
        </transition>
    </div>
</template>

<script>
import I18nService from '~/services/I18nService';
import { mixin as clickaway } from 'vue-clickaway';

// Assets
import locales from '~/data/locales.json';

export default {
    mixins: [clickaway],
    name: 'LocaleDropdown',
    props: {
        noModal: Boolean, // Decides if the dropdown should show or not
    },
    data: () => ({
        showLangList: false,
        languages: locales,
    }),
    computed: {
        currentLocale() {
            let temp = this.$interfaces.localeModule.getLocaleItem();
            return temp;
        },
    },
    methods: {
        onChange(language) {
            // Fixes a bug where the user can still select because of the animation
            if (!this.showLangList) {
                return;
            }

            I18nService.changeLocale(language);
            this.showLangList = false;
            this.$emit('close');
        },
        toggleLangList() {
            if (this.showLangList) {
                // Close
                this.showLangList = false;
                this.$emit('close');
            } else {
                // Open
                this.showLangList = true;
                this.$emit('open');
            }
        },
        selectedToCurrentLocale() {
            const currentLocale = I18nService.getLocale();
            let current = this.languages.find(lang => lang.locale === currentLocale);
            if (!current) {
                current = this.languages[0];
            }

            I18nService.changeLocale(current);
        },
    },
    beforeMount() {
        this.selectedToCurrentLocale();
    },
};
</script>

<style scoped>
.locale-dropdown {
    position: absolute;
    top: 64px;
    right: 55px;
    min-width: 120px;
    max-width: 140px;
    height: auto;

    box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.4);
}
</style>
